import styled from 'styled-components';
import { responsiveBreakPoints } from '@styles/DesignVariables';

const { maxTablet } = responsiveBreakPoints;

export const Footer = styled.footer<{ $backgroundColor?: string }>`
	background-color: ${({ $backgroundColor }) => $backgroundColor || '#232f3e'};
`;

export const FooterWrapper = styled.section`
	padding: 24px 16px;
	max-width: 1032px;
	margin: 0 auto;

	@media screen and (${maxTablet}) {
		padding: 16px;
	}
`;

export const FooterContent = styled.div<{ $textColor: string }>`
	color: ${({ $textColor }) => $textColor};
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
	font-family: "Roboto", sans-serif;
	padding: 12px 13px;

	@media screen and (${maxTablet}) {
		text-align: center;
	}
`;

export const FooterMenu = styled.nav`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	@media screen and (${maxTablet}) {
		display: block;
	}
`;

export const FooterLogo = styled.div`
	max-width: 194px;
	img {
		width: 100%;
		height: auto;
	}
	@media screen and (${maxTablet}) {
		margin: 0 auto;
	}
`;

export const BackButton = styled.a<{ $backgroundColor: string }>`
	font-family: 'Roboto', sans-serif;
	font-weight: 700;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0%;
	text-align: center;
	background: ${({ $backgroundColor }) => $backgroundColor};
	color: #fff;
	padding: 8px 16px;
	border-radius: 20px;
	display: flex;
	gap: 8px;
	flex-grow: 0;
	width: fit-content;
	@media screen and (${maxTablet}) {
		margin: 0 auto;
	}
`;

export const FooterLinks = styled.nav<{ $textColor: string; $linkHover: string }>`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	justify-content: center;
	a {
		color: ${({ $textColor }) => $textColor};
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		text-decoration: none;
		transition: color 150ms ease-in;

		&:hover {
			color: ${({ $linkHover }) => $linkHover};
		}
	}
	@media screen and (${maxTablet}) {
		margin: 24px 0px;
	}
`;

export const FooterCopyright = styled.div``;

export const CopyrightText = styled.p<{ $textColor: string }>`
	color: ${({ $textColor }) => $textColor};
	font-family: Roboto, sans-serif;
	font-size: 14px;
	font-weight: 400;
	line-height: 24px;
	text-align: left;
	@media screen and (${maxTablet}) {
		text-align: center;
	}
`;
